import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VideoAssetsService } from '../../services/video-assets/video-assets.service';
import { VideoRequestsService } from '../../services/video-requests/video-requests.service';
import { WindowService } from '../../services/window/window.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
import * as moment from 'moment';
var VideoRequestComponent = /** @class */ (function () {
    function VideoRequestComponent(activatedRoute, videoAssetsService, videoRequestsService, returnUrlService, windowService) {
        this.activatedRoute = activatedRoute;
        this.videoAssetsService = videoAssetsService;
        this.videoRequestsService = videoRequestsService;
        this.returnUrlService = returnUrlService;
        this.windowService = windowService;
        this.playCounted = [];
        this.reason = '';
        this.returnUrlService.save();
    }
    VideoRequestComponent.prototype.canDownload = function (video) {
        var canDownloadValue = (!this.request.isFreeDownload)
            && (video.status === 'Emailed')
            && (this.request.purgedIn > 0);
        return canDownloadValue;
    };
    VideoRequestComponent.prototype.canReject = function (video) {
        return (this.request.purgedIn > 0)
            && (!this.request.isFreeDownload)
            && (video.playCount < 1)
            && (video.canReject)
            && (video.status === 'Emailed');
    };
    VideoRequestComponent.prototype.isReasonValid = function () {
        return this.reason && !this.reason.match(/^ *$/);
    };
    Object.defineProperty(VideoRequestComponent.prototype, "hoursAgo", {
        get: function () {
            var createdAt = moment.parseZone(this.request.createdAt);
            var now = moment();
            var difference = now.diff(createdAt, 'hours');
            if (difference < 1) {
                return '(< 1 hour ago)';
            }
            return (difference < 24) ? "(" + difference + " hours ago)" : null;
        },
        enumerable: true,
        configurable: true
    });
    VideoRequestComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestIdString, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestIdString = this.activatedRoute.snapshot
                            ? this.activatedRoute.snapshot.paramMap.get('requestId')
                            : null;
                        if (!requestIdString) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.videoRequestsService.get(requestIdString)];
                    case 1:
                        _a.request = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.onDownload = function (event, video) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        video.canReject = false;
                        return [4 /*yield*/, this.videoAssetsService.setHasBeenDownloaded(video.assetId)];
                    case 1:
                        _a.sent();
                        this.windowService.window.location.href = video.highQualityVideoUri;
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.onEnded = function (video, videoTag) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!(this.playCounted[video.assetId] || false)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.incrementPlayCount(video)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.playCounted[video.assetId] = false; // Reset the marker so they have 30 seconds for the next "play"
                        videoTag.currentTime = 0;
                        videoTag.load();
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.onPause = function (video, videoTag) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.incrementPlayCountIfRequired(video, videoTag)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.onPlay = function (video, videoTag) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.incrementPlayCountIfRequired(video, videoTag)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.reject = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var assetId, rejectReason;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.activeVideo.canReject = false;
                        this.activeVideo.rejectionReason = this.reason;
                        this.activeVideo.state = 'Rejected';
                        this.activeVideo.status = 'Rejected';
                        assetId = this.activeVideo.assetId;
                        rejectReason = this.reason;
                        return [4 /*yield*/, this.videoAssetsService.reject(assetId, rejectReason)];
                    case 1:
                        _a.sent();
                        this.activeVideo = null;
                        this.reason = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.showRejectModal = function (video) {
        this.activeVideo = video;
        this.reason = '';
        document.getElementById("videoplayer_" + video.assetId).pause();
    };
    VideoRequestComponent.prototype.calculatePlayedSeconds = function (playedRanges) {
        if (playedRanges == null || playedRanges.length === 0) {
            return 0;
        }
        var totalDuration = 0;
        for (var playedIndex = 0; playedIndex < playedRanges.length; playedIndex++) {
            var rangeDuration = playedRanges.end(playedIndex) - playedRanges.start(playedIndex);
            totalDuration += (isNaN(rangeDuration) ? 0 : rangeDuration);
        }
        return totalDuration;
    };
    VideoRequestComponent.prototype.incrementPlayCount = function (video) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        video.playCount++;
                        return [4 /*yield*/, this.videoAssetsService.incrementPlayCount(video.assetId)];
                    case 1:
                        _a.sent();
                        this.playCounted[video.assetId] = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestComponent.prototype.incrementPlayCountIfRequired = function (video, videoTag) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var shouldIncrementPlayCount, playedSeconds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldIncrementPlayCount = true;
                        if (videoTag != null) {
                            playedSeconds = this.calculatePlayedSeconds(videoTag.played);
                            if (isNaN(playedSeconds) || (playedSeconds === Infinity)) {
                                shouldIncrementPlayCount = true;
                            }
                            else {
                                shouldIncrementPlayCount = (playedSeconds >= 30);
                            }
                        }
                        if (!(!(this.playCounted[video.assetId] || false) && shouldIncrementPlayCount)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.incrementPlayCount(video)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return VideoRequestComponent;
}());
export { VideoRequestComponent };
